import FormCompanySizeOptions from "../en/company-sizes.js";
export default FormCompanySizeOptions;
